import {denormFn, normFn} from '../normalizerSupport';
import type * as Types from './types';

export const normalize = normFn<Types.WorkspaceSettingsObjSchema>(
  'workspace-settings',
  whole => whole
);

export const denormalize = denormFn<Types.WorkspaceSettingsObjSchema>(
  part => part
);
